import { render, staticRenderFns } from "./AcceptanceActions.vue?vue&type=template&id=2ee65a84&scoped=true"
import script from "./AcceptanceActions.vue?vue&type=script&lang=js"
export * from "./AcceptanceActions.vue?vue&type=script&lang=js"
import style0 from "./AcceptanceActions.vue?vue&type=style&index=0&id=2ee65a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee65a84",
  null
  
)

export default component.exports